import React, {CSSProperties, PureComponent} from 'react'
import {observer} from 'mobx-react'
import {T as Traduce} from 'helpers/i18n'
import IconosApp, {Icono} from './IconosApp'
import theme from '../Theme'
import cxs from 'cxs/component'

interface Props<T> {
  icons: string[]
  icon: string

  onChange(name: string, value: string, column?: string): void
}

interface State {
  selected: string
}

class FieldIcon<T> extends PureComponent<Props<T>, State> {

/*  constructor(props: Props<T>, context: any) {
    super(props, context)
    this.state = {selected: props.icon}
    console.log('props.icon: ', this.state.selected)
  }*/

  state: State = {
    selected: this.props.icon
  }

  handleClick = icon => {
    console.log(icon)
    if (this.state.selected === icon) {
      this.setState({selected: ''})
      this.props.onChange('icon', '', 'icon')
    } else {
      this.setState({selected: icon})
      this.props.onChange('icon', icon, 'icon')
    }
  }

  render() {
    const {icons, onChange} = this.props
    const {selected} = this.state
    // console.log('render - selected: ', selected)
    return (
      <div>
        {icons.map((icon, index) =>
          <div
            key={icon}
            onClick={() => this.handleClick(icon)}
            style={{position: 'relative', display: 'inline-block'}}
          >
            {selected === icon
              ? (
                <div>
                  <StyledIconosApp
                    name={Icono[icon]}
                    style={style.selected}
                    /*color={theme.color.primary}*/
                  />
                  <div style={{
                    fontSize: '12px',
                    textAlign: 'center',
                    border: `1px solid ${theme.color.secondary}`,
                    color: theme.color.primary
                  }}>
                    {Icono[icon]}
                  </div>
                </div>
              )
              : (
                <div>
                  <StyledIconosApp
                    name={Icono[icon]} style={style.square}
                    /*hover={theme.color.primary}
                    color={theme.color.secondary}*/
                  />
                  <div style={{
                    fontSize: '12px',
                    textAlign: 'center',
                    border: `1px solid ${theme.color.secondary}`,
                    color: theme.color.secondary
                  }}>
                    {Traduce(Icono[icon])}
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
    )
  }
}

export default FieldIcon

const StyledIconosApp = cxs(IconosApp)({
  /*':hover': {
    color: theme.color.primary
  },*/
})

const style = {
  square: {
    /*fontFamily: 'icons',*/
    fontSize: '70px',
    border: `1px solid ${theme.color.secondary}`
    /*color: theme.color.secondary*/
  },
  selected: {
    /*fontFamily: 'icons',*/
    fontSize: '70px',
    border: `1px solid ${theme.color.secondary}`,
    color: theme.color.primary
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/FieldIcon.tsx